import { StockService } from './../../../services/data/stock.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { StockItem, ItemConfig, Constants } from '@co-assist/library';
import { Input } from '@angular/core';
import { ItemThumbnail } from 'app/models/ItemThumbnails';

@Component({
    selector: 'app-item-inventory',
    templateUrl: './item-inventory.component.html',
    styleUrls: ['./item-inventory.component.scss']
})
export class ItemInventoryComponent implements OnInit {

    isLoading: boolean = false;

    @Input() type: Constants.Admin.BUSINESS_TYPE;
    @Input() itemConfig: ItemConfig = null;
    @Input() deviceFilter: Array<Constants.Entity.DeviceType> = [];

    @Output()
    itemEmitter: EventEmitter<StockItem> = new EventEmitter();
    private items: Array<ItemThumbnail> = [];

    constructor(
        private stockService: StockService,
        private translateService: TranslateService
    ) { }

    get isB2B() {
        return this.type === Constants.Admin.BUSINESS_TYPE.B2B;
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.stockService.getStockItems({ type: this.type }).subscribe(items => {
            this.items = items
                .map(item => new ItemThumbnail(item, this.translateService.currentLang))
                .sort((a, b) => b.stock - a.stock);
            this.translateService.onLangChange.subscribe(translate => {
                this.items.forEach(item => item.langage = translate.lang);
            });
            this.isLoading = false;
        });
        if (!this.isB2B) {
            this.deviceFilter = [Constants.Entity.DeviceType.CAW];
        }
    }

    getNgClass(itemRef: string): Array<string> {
        const ngClass = ['item-card'];
        if (!this.isB2B) {
            ngClass.push('selectable');
            if (this.itemConfig.reference === itemRef) {
                ngClass.push('selectedItem');
            }
        }
        return ngClass;
    }

    getStockDisplay(stock: number): string {
        const [text, param] = stock > 0 ? ['CATALOG.STOCK', { stock: stock }] : ['CATALOG.OUT_STOCK'];
        return this.translateService.instant(text, param);
    }

    getItems(device: Constants.Entity.DeviceType): Array<ItemThumbnail> {
        return this.items.filter(item => item.associatedDevices.includes(device));
    }

    selectItem(item: ItemThumbnail) {
        if (!this.isB2B) {
            this.itemEmitter.emit(item);
        }
    }
}
